import { cn } from "lib/utils";
import LegoWoman from "assets/lego-woman.png";

export default function MessageBanner({
  colour = "red",
  title,
  body,
  className,
  children,
  image = null,
  ...props
}) {
  return (
    <div className={cn("w-full", image && "md:pt-6")}>
      <div
        className={cn(
          `bg-${colour}-300 bg-opacity-[0.5] flex rounded-lg w-full relative h-full ${
            image && ""
          }`,
          className
        )}
        {...props}
      >
        <div
          className={`absolute top-0 bottom-0 left-0 w-[5px] bg-${colour} shrink-0 z-10 rounded-l-lg`}
        ></div>
        <div className="flex flex-col p-4">
          {title && <div className="font-semibold">{title}</div>}
          {body && <div className="text-secondary text-sm">{body}</div>}
          {children}
        </div>
        {image && (
          <div className="w-[100px] h-full relative bg-yellow self-end hidden md:block shrink-0">
            <img
              src={LegoWoman}
              alt="Lego Woman"
              className="w-[100px] object-contain absolute bottom-0 shrink-0"
            />
          </div>
        )}
      </div>
    </div>
  );
}
